export type EntityKind =
    | "Client"
    | "Community"
    | "HomeCareLead"
    | "ReferenceContact"
    | "ReferenceBusiness";

export interface EntityInfo {
    displayName: string;
    path: string;
    kind: EntityKind;
}

const entityKindToTypename: Record<
    EntityKind,
    | "ClientEntity"
    | "CommunityEntity"
    | "HomeCareLeadEntity"
    | "ReferenceContactEntity"
    | "ReferenceBusinessEntity"
> = {
    Client: "ClientEntity",
    Community: "CommunityEntity",
    HomeCareLead: "HomeCareLeadEntity",
    ReferenceContact: "ReferenceContactEntity",
    ReferenceBusiness: "ReferenceBusinessEntity",
};

export const getEntityTypename = (kind: EntityKind) => entityKindToTypename[kind];
